import { useEffect, useState } from 'react'
import { toastSweetAlert } from '../Components/Helpers/ToastSweetAlert'

export default function InternetWarning() {
  const [status, setStatus] = useState(navigator.onLine ? 'hidden' : 'show')
  const [justReconnected, setJustReconnected] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setJustReconnected(true)
      setStatus('show')

      // Mostrar mensaje por 1 segundo
      setTimeout(() => {
        setStatus('hide')

        toastSweetAlert({
          title: 'Conexión a internet restablecida',
          mode: 'loading',
          message: 'Recargando página.. Espére un momento!',
          icon: 'success',
        })
        // Esperar animación de salida (1s) antes de ocultar completamente
        setTimeout(() => {
          setStatus('hidden')
          setJustReconnected(false)

          // Recargar la página después de mostrar el mensaje
          window.location.reload()
        }, 1000)
      }, 1000)
    }

    const handleOffline = () => {
      setJustReconnected(false)
      setStatus('show')
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (status === 'hidden') return null

  return (
    <div
      className={`internet-warning ${status}`}
      style={{
        backgroundColor: justReconnected ? '#4caf50' : '#d9381b',
      }}
    >
      {justReconnected
        ? '✅ ¡Conexión restablecida! ✅'
        : '⚠️ Parece que no tienes conexión a internet. Intenta reconectarte. ⚠️'}
    </div>
  )
}
